import { __assign, __awaiter, __generator } from "tslib";
import { useState, useCallback } from "react";
import { UniqueContainerSet } from "../UniqueContainerId/UniqueContainerSet";
import { isChildrenNotLoaded, isParentTreeItemType, } from "../Utils/ContainerUtil";
import { ChildLoadState } from "../models/ChildLoadState";
import { insertChildIntoTree } from "../API/conversionMethods";
var UseContainerTreeOptionsDefaults = {
    data: []
};
export function useContainerTree(options) {
    var _this = this;
    var _a = options.data, data = _a === void 0 ? [] : _a, componentOverrides = options.componentOverrides, onClick = options.onClick, onExpandClick = options.onExpandClick, onCursorMove = options.onCursorMove, onMouseLeave = options.onMouseLeave, onMouseEnter = options.onMouseEnter, onContextMenu = options.onContextMenu, onEnter = options.onEnter, onSpace = options.onSpace, onTabOut = options.onTabOut, onShiftTabOut = options.onShiftTabOut, initialFocusItem = options.initialFocusItem, _b = options.parentTypesSelectable, parentTypesSelectable = _b === void 0 ? true : _b, _c = options.multiselect, multiselect = _c === void 0 ? false : _c, _d = options.selectOnCursorMove, selectOnCursorMove = _d === void 0 ? false : _d, _e = options.expandParentTypeOnClick, expandParentTypeOnClick = _e === void 0 ? false : _e, _f = options.selectedSet, selectedSet = _f === void 0 ? new UniqueContainerSet() : _f, _g = options.expandedSet, expandedSet = _g === void 0 ? new UniqueContainerSet() : _g, expandAction = options.expandAction, clickAction = options.clickAction, doubleClickAction = options.doubleClickAction, fetchChildren = options.fetchChildren, indentPerTreeLevel = options.indentPerTreeLevel, overScanSize = options.overScanSize;
    var _h = useState(data), newData = _h[0], setData = _h[1];
    var _j = useState(selectedSet), newSelectedSet = _j[0], setSelectedSet = _j[1];
    var clearSelectedSet = function () {
        setSelectedSet(new UniqueContainerSet());
    };
    var _k = useState(expandedSet), newExpandedSet = _k[0], setExpandedSet = _k[1];
    var clearExpandedSet = function () {
        setExpandedSet(new UniqueContainerSet());
    };
    var newOnExpandClick = onExpandClick ||
        useCallback(function (containerData, event) { return __awaiter(_this, void 0, void 0, function () {
            var newNode_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setExpandedSet(function (prevState) {
                            var copySet = new UniqueContainerSet(prevState);
                            if (!copySet["delete"](containerData)) {
                                copySet.add(containerData);
                            }
                            return copySet;
                        });
                        if (expandAction) {
                            expandAction(containerData, event);
                        }
                        if (!(isChildrenNotLoaded(containerData.childData) &&
                            fetchChildren)) return [3 /*break*/, 2];
                        setData(function (prev) {
                            var loadingNode = __assign(__assign({}, containerData), { childData: { loadState: ChildLoadState.loading } });
                            return insertChildIntoTree(prev, loadingNode);
                        });
                        return [4 /*yield*/, fetchChildren(containerData)];
                    case 1:
                        newNode_1 = _a.sent();
                        setData(function (prev) {
                            return insertChildIntoTree(prev, newNode_1);
                        });
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); }, [data, newExpandedSet]);
    var newOnClick = onClick ||
        useCallback(function (containerData, event) {
            if (expandParentTypeOnClick &&
                isParentTreeItemType(containerData.containerType)) {
                newOnExpandClick(containerData, event);
            }
            if (!parentTypesSelectable &&
                isParentTreeItemType(containerData.containerType)) {
                return;
            }
            if (multiselect) {
                setSelectedSet(function (prevState) {
                    var copySet = new UniqueContainerSet(prevState);
                    if (!copySet["delete"](containerData)) {
                        copySet.add(containerData);
                    }
                    return copySet;
                });
            }
            else {
                var newSet = new UniqueContainerSet();
                newSet.add(containerData);
                setSelectedSet(newSet);
            }
            var currentClickCount = event.detail;
            if (doubleClickAction && currentClickCount === 2) {
                doubleClickAction(containerData, event);
            }
            else if (clickAction) {
                clickAction(containerData, event);
            }
        }, [newSelectedSet]);
    var newOnCursorMove = onCursorMove ||
        useCallback(function (containerData, event) {
            if (selectOnCursorMove) {
                if (!parentTypesSelectable &&
                    isParentTreeItemType(containerData.containerType)) {
                    clearSelectedSet();
                }
                else {
                    var copySet = new UniqueContainerSet();
                    copySet.add(containerData);
                    setSelectedSet(copySet);
                }
            }
        }, [newSelectedSet]);
    var containerTreeProps = {
        data: newData,
        componentOverrides: componentOverrides,
        onClick: newOnClick,
        onExpandClick: newOnExpandClick,
        onContextMenu: onContextMenu,
        onCursorMove: newOnCursorMove,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onTabOut: onTabOut,
        onShiftTabOut: onShiftTabOut,
        onEnter: onEnter,
        onSpace: onSpace,
        initialFocusItem: initialFocusItem,
        selectedSet: newSelectedSet,
        expandedSet: newExpandedSet,
        indentPerTreeLevel: indentPerTreeLevel,
        overScanSize: overScanSize
    };
    return {
        data: newData,
        setData: setData,
        containerTreeProps: containerTreeProps,
        selectedSet: newSelectedSet,
        setSelectedSet: setSelectedSet,
        clearSelectedSet: clearSelectedSet,
        expandedSet: newExpandedSet,
        setExpandedSet: setExpandedSet,
        clearExpandedSet: clearExpandedSet
    };
}
//# sourceMappingURL=useContainerTree.js.map